/* tslint:disable */
/* eslint-disable */
/**
 * Pharma-Auth User registration rule API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { StatusValueRestDto } from '../models';
import { UrrSimulationInputRestDto } from '../models';
import { UrrSimulationOutputRestDto } from '../models';
import { UserRegistrationOverviewResultsRestDto } from '../models';
/**
 * UserRegistrationRuleEndpointsApi - axios parameter creator
 * @export
 */
export const UserRegistrationRuleEndpointsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary REST.API.AUTH.URR.01 Find the user registration rules
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        findUserRegistrationRules: async (x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/user_registration_rule/v1/user_registration_rule`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.URR.04 Simulate the execution of all the published user registration rules.
         * @param {UrrSimulationInputRestDto} body 
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulatePublishedUserRegistrationRules: async (body: UrrSimulationInputRestDto, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling simulatePublishedUserRegistrationRules.');
            }
            const localVarPath = `/user_registration_rule/v1/user_registration_rule/simulate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.URR.03 Simulate the execution of the user registration rule.
         * @param {UrrSimulationInputRestDto} body 
         * @param {string} rule_id The unique identifier of this user registration rule.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateUserRegistrationRule: async (body: UrrSimulationInputRestDto, rule_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling simulateUserRegistrationRule.');
            }
            // verify required parameter 'rule_id' is not null or undefined
            if (rule_id === null || rule_id === undefined) {
                throw new RequiredError('rule_id','Required parameter rule_id was null or undefined when calling simulateUserRegistrationRule.');
            }
            const localVarPath = `/user_registration_rule/v1/user_registration_rule/{rule_id}/simulate`
                .replace(`{${"rule_id"}}`, encodeURIComponent(String(rule_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.URR.02 Update the field status_code of the user registration rule.
         * @param {StatusValueRestDto} body 
         * @param {string} rule_id The unique identifier of this user registration rule.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUrrStatusCode: async (body: StatusValueRestDto, rule_id: string, x_dp_customer_code?: string|null, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            if (body === null || body === undefined) {
                throw new RequiredError('body','Required parameter body was null or undefined when calling updateUrrStatusCode.');
            }
            // verify required parameter 'rule_id' is not null or undefined
            if (rule_id === null || rule_id === undefined) {
                throw new RequiredError('rule_id','Required parameter rule_id was null or undefined when calling updateUrrStatusCode.');
            }
            const localVarPath = `/user_registration_rule/v1/user_registration_rule/{rule_id}/status`
                .replace(`{${"rule_id"}}`, encodeURIComponent(String(rule_id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication BearerAuth required

            if (x_dp_customer_code !== undefined && x_dp_customer_code !== null) {
                localVarHeaderParameter['x-dp-customer-code'] = String(x_dp_customer_code);
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserRegistrationRuleEndpointsApi - functional programming interface
 * @export
 */
export const UserRegistrationRuleEndpointsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary REST.API.AUTH.URR.01 Find the user registration rules
         * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async findUserRegistrationRules(_axios: AxiosInstance, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserRegistrationOverviewResultsRestDto>> {
            const localVarAxiosArgs = await UserRegistrationRuleEndpointsApiAxiosParamCreator(configuration).findUserRegistrationRules(x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.URR.04 Simulate the execution of all the published user registration rules.
         * @param {UrrSimulationInputRestDto} body 
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async simulatePublishedUserRegistrationRules(_axios: AxiosInstance, body: UrrSimulationInputRestDto, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UrrSimulationOutputRestDto>> {
            const localVarAxiosArgs = await UserRegistrationRuleEndpointsApiAxiosParamCreator(configuration).simulatePublishedUserRegistrationRules(body, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.URR.03 Simulate the execution of the user registration rule.
         * @param {UrrSimulationInputRestDto} body 
         * @param {string} rule_id The unique identifier of this user registration rule.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async simulateUserRegistrationRule(_axios: AxiosInstance, body: UrrSimulationInputRestDto, rule_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UrrSimulationOutputRestDto>> {
            const localVarAxiosArgs = await UserRegistrationRuleEndpointsApiAxiosParamCreator(configuration).simulateUserRegistrationRule(body, rule_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * 
         * @summary REST.API.AUTH.URR.02 Update the field status_code of the user registration rule.
         * @param {StatusValueRestDto} body 
         * @param {string} rule_id The unique identifier of this user registration rule.
         * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUrrStatusCode(_axios: AxiosInstance, body: StatusValueRestDto, rule_id: string, x_dp_customer_code?: string|null, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await UserRegistrationRuleEndpointsApiAxiosParamCreator(configuration).updateUrrStatusCode(body, rule_id, x_dp_customer_code, options);
            return (axios: AxiosInstance = _axios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * UserRegistrationRuleEndpointsApi - object-oriented interface
 * @export
 * @class UserRegistrationRuleEndpointsApi
 * @extends {BaseAPI}
 */
export class UserRegistrationRuleEndpointsApi extends BaseAPI {
    /**
     * 
     * @summary REST.API.AUTH.URR.01 Find the user registration rules
     * @param {string} [x_dp_customer_code] Code that uniquely identifies the Digital Pharma customer.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRegistrationRuleEndpointsApi
     */
     public findUserRegistrationRules(x_dp_customer_code?: string|null, options?: any) {
        return UserRegistrationRuleEndpointsApiFp(this.configuration).findUserRegistrationRules(this.axios, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.AUTH.URR.04 Simulate the execution of all the published user registration rules.
     * @param {UrrSimulationInputRestDto} body 
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRegistrationRuleEndpointsApi
     */
     public simulatePublishedUserRegistrationRules(body: UrrSimulationInputRestDto, x_dp_customer_code?: string|null, options?: any) {
        return UserRegistrationRuleEndpointsApiFp(this.configuration).simulatePublishedUserRegistrationRules(this.axios, body, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.AUTH.URR.03 Simulate the execution of the user registration rule.
     * @param {UrrSimulationInputRestDto} body 
     * @param {string} rule_id The unique identifier of this user registration rule.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRegistrationRuleEndpointsApi
     */
     public simulateUserRegistrationRule(body: UrrSimulationInputRestDto, rule_id: string, x_dp_customer_code?: string|null, options?: any) {
        return UserRegistrationRuleEndpointsApiFp(this.configuration).simulateUserRegistrationRule(this.axios, body, rule_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary REST.API.AUTH.URR.02 Update the field status_code of the user registration rule.
     * @param {StatusValueRestDto} body 
     * @param {string} rule_id The unique identifier of this user registration rule.
     * @param {string} [x_dp_customer_code] The unique identification of the Customer. If not provided, the request is handled in Digital-Pharma context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserRegistrationRuleEndpointsApi
     */
     public updateUrrStatusCode(body: StatusValueRestDto, rule_id: string, x_dp_customer_code?: string|null, options?: any) {
        return UserRegistrationRuleEndpointsApiFp(this.configuration).updateUrrStatusCode(this.axios, body, rule_id, x_dp_customer_code, options).then((request) => request(this.axios, this.basePath));
    }

}
